'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;



/*****************
 ** WEBPACK FOOTER
 ** ./~/gopd/gOPD.js
 ** module id = 709
 ** module chunks = 0
 **/